<template>
  <div class="footer-index">
    <div class="footer-top"></div>
    <div class="footer-content">
      <el-row>
        <el-col :span="18">
          <div class="content-left">
            <img class="left-logo" src="~@/assets/images/egpc-logo-white.png" alt="">
            <p class="left-title">Create International Study Opportunities For All Youth.</p>
            <p class="left-text phone">025-58895599</p>
            <p class="left-text email">egpcexpo@istudyedu.com</p>
            <p class="left-text city">江苏省南京市浦口区星火路19号星智汇商务花园A5栋9层</p>
          </div>
        </el-col>
        <el-col :span="6">
          <!-- <div class="content-rig">
            <p class="rig-title">新闻</p>
            <ul class="rig-item">
              <li class="rig-item-list">
                <div class="list-lf">
                  <p class="list-num">MAR4</p>
                  <img class="list-img" src="" alt="">
                </div>
                <div class="list-rig">
                  <p class="list-title">Early Bird Registration is now available for students</p>
                  <p class="list-text">Curabitur auctor pulvinar odio, vitae egestas neque sodales quis. Sed...</p>
                </div>
              </li>
            </ul>
          </div> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerIndex',
  props: {},
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {},
  methods: {}
}
</script>

<style scoped>
.footer-index{background-color:#182c61 ;border-color:#182c61 ;color:#f9f9f9;padding:100px 0;position:relative;z-index:9;transition:all 300ms ease-in-out;}
.footer-index .footer-top{position:absolute;width:100%;background-color:#182c61 ;border-color:#182c61 ;z-index:1;top:0;}
/* .footer-index .footer-top::before{content:'';width:0;height:0;border-style:solid;border-color:#182c61 ;border-width:32px 0 0 900px;border-width: 32px 0 0 50vw;border-left-width: 900px;border-left-width: 50vw;position: absolute;z-index: 9;top:-31px;border-top-color:transparent;border-bottom-color:transparent;left: 49.99%;} */
/* .footer-index .footer-top::after{content:'';width:0;height:0;border-style:solid;border-color:#182c61 ;border-width:32px 0 0 900px;border-width: 32px 0 0 50vw;border-left-width: 900px;border-left-width: 50vw;position: absolute;z-index: 9;top:-31px;border-top-color:transparent;border-bottom-color:transparent;right: 49.99%;transform:rotateY(180deg);} */
.footer-index .footer-content{width:1170px;margin:0 auto;}
.footer-index .footer-content .left-logo{display: block;height:70px;margin-bottom:20px;}
.footer-index .footer-content .left-title{margin-bottom:20px;font-weight:600;}
.footer-index .footer-content .left-text{padding-left:40px;line-height:36px;font-size:16px;margin-bottom:20px;background:url('~@/assets/images/footer-icon-phone.png') left center no-repeat;background-size:32px;}
.footer-index .footer-content .left-text.email{background-image:url('~@/assets/images/footer-icon-email.png');}
.footer-index .footer-content .left-text.city{background-image:url('~@/assets/images/footer-icon-city.png');}
.footer-index .footer-content .content-rig .rig-title{font-size:19px;margin-bottom:30px;font-weight:600;position:relative;}
.footer-index .footer-content .content-rig .rig-title::after{display: block;content:'';width:80%;position: absolute;top:50%;left:50px;height:1px;background-color:#f9f9f9;}
.footer-index .footer-content .content-rig .rig-item-list{margin-bottom:10px;overflow:hidden;}
.footer-index .footer-content .content-rig .rig-item-list .list-lf{float:left;position:relative;}
.footer-index .footer-content .content-rig .rig-item-list .list-img{display:block;width:65px;height:100px;}
.footer-index .footer-content .content-rig .rig-item-list .list-num{position: absolute;left:0;width:100%;top:0;text-align: center;background-color:rgba(0, 0, 0, 0.4);line-height:24px;}
.footer-index .footer-content .content-rig .rig-item-list .list-rig{margin-left:75px;}
.footer-index .footer-content .content-rig .rig-item-list .list-rig .list-title{color:#64b9ee;font-size:16px;font-weight:600;margin-bottom:10px;}
.footer-index .footer-content .content-rig .rig-item-list .list-rig .list-text{font-size:14px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;word-break: break-all;}
</style>
